import {useEffect, useState} from "react";
import ProjectTechStackItem from "./ProjectTechStackItem";

interface IProjectTechStack {
    items: Array<string>,
    className: string
}

export default function ProjectTechStack(props: IProjectTechStack) {

    return <div className={'flex gap-2 flex-wrap text-xs items-center ' + props.className}>
        {props?.items?.map((el, i) => {
            return <ProjectTechStackItem key={i} item={el}/>
        })}
    </div>
}